module.exports = __webpack_public_path__ + "static/media/kew_outside.23c981bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/about/kew_outside.jpg
// module id = 311
// module chunks = 0